import styled from 'styled-components'
export const LogoHeader = styled.div<{
  bgColor?: string
}>`
  height: 200px;
  background-color: ${(props) => props.bgColor || 'rgba(44, 44, 44,1)'};
`
